import { Button, Modal } from "@devhop/ui";
import { CheckCircle } from "lucide-react";
import type { MeetingActionListItem } from "@/modules/management/meeting-minutes/domain/types";
import { formatDateLocal } from "@/shared/lib/date-time";
import { MeetingActionStatusBadge } from "./MeetingActionStatusBadge";

type ActionDetailModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: MeetingActionListItem | null;
  onMarkDone?: (row: MeetingActionListItem) => void;
};

export function ActionDetailModal({
  open,
  onOpenChange,
  action,
  onMarkDone,
}: ActionDetailModalProps) {
  if (!action) return null;

  const canMarkDone = onMarkDone && action.status === "pending";

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="ລາຍລະອຽດປະເດັນ"
      size="lg"
    >
      <div className="space-y-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <p className="text-muted-foreground text-sm">ຫົວຂໍ້ປະຊຸມ</p>
            <p className="font-medium">{action.meetingTitle || "—"}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ຜູ້ສ້າງບັນທຶກ</p>
            <p className="font-medium">{action.meetingCreatedByName || "—"}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ວັນທີປະຊຸມ</p>
            <p className="font-medium">{formatDateLocal(action.meetingDate)}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ຜູ້ຮັບຜິດຊອບ</p>
            <p className="font-medium">{action.assigneeName || "—"}</p>
          </div>
          {action.dueDate && (
            <div>
              <p className="text-muted-foreground text-sm">ວັນສົ່ງ</p>
              <p className="font-medium">{formatDateLocal(action.dueDate)}</p>
            </div>
          )}
          <div>
            <p className="text-muted-foreground text-sm">ສະຖານະ</p>
            <MeetingActionStatusBadge status={action.status} />
          </div>
        </div>

        <div>
          <p className="text-muted-foreground text-sm">ລາຍລະອຽດປະເດັນ</p>
          <div
            className="prose prose-sm dark:prose-invert mt-1 max-w-none [&_ol]:list-decimal [&_ul]:list-disc"
            // biome-ignore lint/security/noDangerouslySetInnerHtml: Action description is trusted HTML from TipTap editor
            dangerouslySetInnerHTML={{ __html: action.description }}
          />
        </div>

        {canMarkDone && (
          <div className="border-t pt-4">
            <Button
              type="button"
              variant="outline"
              className="w-full gap-2"
              onClick={() => {
                onMarkDone?.(action);
                onOpenChange(false);
              }}
            >
              <CheckCircle className="h-4 w-4" />
              ມາກເປັນສຳເລັດ
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}
